import { render } from "./customer-list.html?vue&type=template&id=5f546caa&scoped=true&ts=true"
import script from "./customer-list.vue?vue&type=script&lang=ts"
export * from "./customer-list.vue?vue&type=script&lang=ts"

import "./customer-list.scss?vue&type=style&index=0&id=5f546caa&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f546caa"]])

export default __exports__